import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Input } from './ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BASE = ['COLLECTION LOTUS', 'COLLECTION TULIPS', 'COLLECTION COSMOS', 'COLLECTION IKIGAI'];
const OTHER = '__other__';

export const CollectionPicker = ({ value, onChange }) => {
  const [options, setOptions] = useState(BASE);
  const [custom, setCustom] = useState(false);

  useEffect(() => {
    axios.get(`${API}/garments`).then(({ data }) => {
      const found = data.map((g) => (g.collection || '').trim().toUpperCase()).filter((c) => c && c !== 'COLLECTION DREAMS');
      setOptions([...new Set([...BASE, ...found])]);
    }).catch(() => {});
  }, []);

  const isKnown = options.includes((value || '').toUpperCase());

  return (
    <div className="space-y-2">
      <select
        id="collection"
        value={custom || (value && !isKnown) ? OTHER : (value || '').toUpperCase()}
        onChange={(e) => {
          if (e.target.value === OTHER) { setCustom(true); onChange(''); return; }
          setCustom(false);
          onChange(e.target.value);
        }}
        required
        className="w-full h-10 border border-input bg-background px-3 text-sm"
        data-testid="select-collection"
      >
        <option value="" disabled>Elige la colección…</option>
        {options.map((c) => <option key={c} value={c}>{c.replace('COLLECTION ', '')}</option>)}
        <option value={OTHER}>+ Nueva colección…</option>
      </select>
      {(custom || (value && !isKnown)) && (
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          placeholder="Ej: COLLECTION IKIGAI"
          required
          data-testid="input-collection"
        />
      )}
    </div>
  );
};
